// extracted by mini-css-extract-plugin
export default {"link":"Disable_link__NN8cP"};